<script lang="ts">
	//Hooks
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';
	//Design system components
	import {
		ActionsContainer,
		AdvancedCard,
		DeviceButton,
		IconButton,
		Text,
		Toggle,
	} from '@Shelly/shelly-design-system';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import type { ScripsHelper } from '../scripts_helpers';
	// Types
	import type { InputClickEvent } from 'src/types/InputClickEvent';
	import { real_id } from 'src/helpers/interface_helpers';

	let className = '';
	export { className as class };
	export let scripsHelper: ScripsHelper, scriptID: number;

	let waitForToggleResponse = false,
		waitForRunResponse = false;

	const dispatch = createEventDispatcher();
	const deviceID = scripsHelper.deviceID;
	const toggleScript = async (e: InputClickEvent) => {
		if (waitForToggleResponse) return;
		waitForToggleResponse = true;
		await scripsHelper.toggleScript(scriptID, e.target.checked);
		waitForToggleResponse = false;
	};
	const runScript = async () => {
		if (waitForRunResponse) return;
		waitForRunResponse = true;
		await scripsHelper.runScript(scriptID, running ? 'stop' : 'start');
		waitForRunResponse = false;
	};

	$: statusStore = getDeviceStatus(deviceID);
	$: running = $statusStore?.[`script:${scriptID}`]?.running;
	$: settingsStore = getDeviceSettings(deviceID);
	$: enable = $settingsStore?.[`script:${scriptID}`]?.enable;
	$: settingsStore = getDeviceSettings(deviceID);
	$: title = $settingsStore?.[`script:${scriptID}`]?.name || `script_${scriptID}`;
</script>

<AdvancedCard class={className} {title} hideSlotTitle={false} leftSlotBackground>
	<div slot="left" class="d-flex justify-content-center flex-direction-column align-items-center">
		<Toggle
			size="m"
			checked={enable}
			on:click={toggleScript}
			aria-label={$format('text_toggle_script_run_on_startup', {
				default: 'Run on startup',
			})}
			id="toggle-5y0xrcf"
		/>
		<Text styleType="miniature" class="text-center"
			>{@html $format('text_toggle_script_run_on_startup', {
				default: 'Run on{br}startup',
				values: { br: '<br/>' },
			})}</Text
		>
	</div>

	<div slot="right" class="d-flex">
		<DeviceButton
			id="devicebutton-xntdlp0"
			aria-label={$format(running ? 'button_stop_script' : 'button_run_script', {
				default: running ? 'Stop script' : 'Run script',
			})}
			class="align-self-center"
			style="margin-right:6px"
			icon="fas fa-play"
			size="m"
			variant="primary"
			isActive={running}
			isLoading={waitForRunResponse}
			on:click={runScript}
		/>

		<ActionsContainer orientation="vertical" type="simple">
			<IconButton
				icon="fas fa-pen"
				slot="first"
				variant="primary"
				on:click={() => {
					dispatch('editScript');
				}}
				aria-label={$format('button_edit', { default: 'Edit' })}
			/>
			<IconButton
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				on:click={() => {
					dispatch('deleteScript', {
						scriptId: scriptID,
					});
				}}
				aria-label={$format('button_delete', { default: 'Delete' })}
			/>
		</ActionsContainer>
	</div>
</AdvancedCard>
